import { NgModule } from '@angular/core'
import { BadRequestHandler, HttpErrorHandler } from '@spartacus/core'
import { EbBadRequestHandler } from './http-interceptors/bad-request/eb-bad-request-handler'
import { EbNotFoundHandler } from './http-interceptors/not-found/eb-not-found-handler'

@NgModule({
  providers: [
    {
      provide: HttpErrorHandler,
      useExisting: EbNotFoundHandler,
      multi: true
    },
    {
      provide: BadRequestHandler,
      useExisting: EbBadRequestHandler
    }
  ]
})
export class EbGlobalMessageModule {}
